import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Creators as TicketSaleCreators } from '../../../ducks/ticket-sale/ticket-sale'
import {
	StyledContainerInput,
	StyledLabel,
	StyledInputPure,
} from '../../../components/form-components/light-select-search-bar-async/styled-input.style'

class RequestNumberComponent extends React.Component {
	constructor(props) {
		super(props)
		this.handleChangeRequestNumber = this.handleChangeRequestNumber.bind(this)
	}

	handleChangeRequestNumber(event) {
		const { value } = event.target
		this.props.setRequestNumber(value)
	}

	render() {
		return (
			<StyledContainerInput>
				<StyledLabel>Digite o número da requisição</StyledLabel>
				<StyledInputPure
					label="Digite o número da requisição"
					type="text"
					onChange={this.handleChangeRequestNumber}
					values={this.props.requestNumber}
				/>
			</StyledContainerInput>
		)
	}
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			setRequestNumber: TicketSaleCreators.setRequestNumber,
		},
		dispatch
	)

const mapStateToProps = (store) => ({
	requestNumber: store.ticketSale.requestNumber,
})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RequestNumberComponent)
